import { useCallback } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import { Flex } from 'core-components/library/flex'
import { Input } from 'core-components/library/inputs'
import { IPropertiesEnumValues } from 'core-components/sitebuilder/propertygenerator/models/IProperties'
import { useStaticCrud } from 'core-components/types/helpers'

import styles from './StaticDropdown.module.scss'

interface IStaticDropdown {
  itemsData: IPropertiesEnumValues[]
  value: string
  onChange: (value: string) => void
  defaultValue: string
  onDefaultValueChange: (defaultValue: string, key: string) => void
  className: string
  label: string
  hasHierarchy: boolean
}

export const StaticDropdown = ({
  itemsData,
  value,
  onChange,
  defaultValue,
  onDefaultValueChange,
  label,
  className,
  hasHierarchy,
}: IStaticDropdown) => {
  const source = useStaticCrud({
    data: itemsData,
    hierarchyField: 'parent',
    hierarchyRoot: 'null',
    pageSize: 10000,
  })

  const itemTemplate = useCallback((item: IPropertiesEnumValues) => {
    return (
      <Flex flexDirection={'column'}>
        <div>{item.value}</div>
        <div className={styles.additional}>{item.description}</div>
      </Flex>
    )
  }, [])

  return (
    <Flex>
      <Dropdown
        source={source}
        value={value}
        onChange={onChange}
        caption={'value'}
        label={label}
        renderFunction={itemTemplate}
        classes={{ controlClasses: { root: className } }}
        hasHierarchy={hasHierarchy}
        hierarchyField={'hasChildren'}
      />
      <Input
        disabled={!value}
        label={'Default value'}
        value={defaultValue}
        onChange={(newDefault) => onDefaultValueChange(newDefault, value)}
      />
    </Flex>
  )
}
